import { AppConstant } from 'src/app/config/app.constant';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * Dedicated service for park/place multipart uploads (e.g. city image).
 * Does NOT set Content-Type so the browser sends multipart/form-data with boundary.
 * Same pattern as FacilityUploadService and MeetingRoomUploadService.
 */
@Injectable({
  providedIn: 'root',
})
export class ParkUploadService {
  constructor(private http: HttpClient) {}

  /**
   * POST FormData to the given URL without Content-Type header
   * so the browser sets multipart/form-data with boundary.
   */
  postFormData(url: string, formData: FormData): Observable<any> {
    const headersObj: Record<string, string> = {
      TenantId: btoa('0'),
    };
    const token = localStorage.getItem(AppConstant.localStorage.token);
    if (token) {
      headersObj['Authorization'] = 'bearer ' + token;
    }
    const options = {
      headers: new HttpHeaders(headersObj),
    };
    return this.http.post(url, formData, options).pipe(
      map((response) => response),
      catchError((err) => {
        switch (err.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 500:
          case 413:
          case 0:
            break;
        }
        return throwError(err);
      })
    );
  }
}
